export default function ({ $axios, store, route, redirect, app }) {
	// Pokud existuje token v userLogin store, tak setni token v axios
	if (store.state.userLogin.userLoginData.token.value !== null) {
		$axios.setToken(store.state.userLogin.userLoginData.token.value, 'Bearer');
	}
	// Pokud není uživatel přihlášený, vyhoď ho pryč, ale zachovej případnou původní adresu, aby se po přihlášení dostal zpět
	else {
		return redirect(`/?backlink=${ app.localePath(route.path) }&backlinkQuery=${ JSON.stringify(route.query) }`);
	}

}
